import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess(packing_house_id, packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/production/palletized/${packing_house_id}/show_process/${packing_house_process_id}`
    );
  },

  fetchAgroExporterProcesses(packing_house_id, packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/production/palletized/${packing_house_id}/new_package_group/fetch_agro_exporter_processes/${packing_house_process_id}`
    );
  },

  fetchUnassignedPackages(packing_house_id, packing_house_process_id, filters) {
    let route = `packing_house/production/palletized/${packing_house_id}/new_package_group/fetch_unassigned_packages/${packing_house_process_id}`;
    if (filters) route = `${route}?${filters}`;
    return RequesterV1.get(route);
  },

  create(packing_house_id, packing_house_process_id, package_group) {
    return RequesterV1.post(
      `packing_house/production/palletized/${packing_house_id}/new_package_group/create/${packing_house_process_id}`,
      { package_group }
    );
  },
};
